import { render } from "./VirtualNumberFavorites.vue?vue&type=template&id=fbcd5c32"
import script from "./VirtualNumberFavorites.vue?vue&type=script&lang=js"
export * from "./VirtualNumberFavorites.vue?vue&type=script&lang=js"

import "./VirtualNumberFavorites.vue?vue&type=style&index=0&id=fbcd5c32&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__